import styled from '@emotion/styled';

const styleOnlyProps: PropertyKey[] = ['theme', 'as', 'round', 'objectFit', 'maxWidth'];

// Style as a plain <img> (not via Image) so fetchpriority is not stripped by a second Emotion layer.
const CardImage = styled('img', {
  shouldForwardProp: (prop) => !styleOnlyProps.includes(prop),
})({
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  objectFit: 'cover',
  display: 'block',
});

export default CardImage;
